import React, { Component } from 'react';
import classnames from 'classnames';
import { string, arrayOf, object, bool } from 'prop-types';

import Carousel from 'common/Carousel/Carousel';
import CarouselPagination from 'elements/Pagination/CarouselPagination/CarouselPagination';
import OfferBlock from './OfferBlock/OfferBlock';
import StatisticBlock from './StatisticBlock/StatisticBlock';
import { isMobileHOC } from 'common/utils';

import styles from './AdvantagesBanner.css';

class AdvantagesBanner extends Component {
  constructor (props) {
    super(props);

    this.totalStatistics = props.statistics.length;
  }

  static propTypes = {
    className: string,
    offers: arrayOf(object).isRequired,
    statistics: arrayOf(object).isRequired,
    backgroundImage: string,
    isMobile: bool
  }

  state = {
    activeSlide: null
  }

  swiper = null;
  totalStatistics= null;

  onMountSwiper = (instance) => {
    this.swiper = instance;

    this.getSwiperDetails();

    this.swiper.on('slideChange', this.getSwiperDetails); 
  }

  getSwiperDetails = () => this.setState({ activeSlide: this.swiper.realIndex + 1 });

  onDismountSwiper = () => this.swiper.off('slideChange', this.getSwiperDetails);
  
  carouselHandler = ({ currentPage }) => {
    this.setState({ activeSlide: currentPage });
    this.swiper.slideToLoop(currentPage - 1);
  }
  
  renderStatisticsCarousel = () => {
    const { statistics } = this.props;
    const options = {
      loop: true
    };

    return (
      <Carousel
        className={styles.swipperContainer}
        options={options}
        onMount={this.onMountSwiper}
        onDismount={this.onDismountSwiper}
      >
        {statistics.map((statistic, i) => 
          <li className="swiper-slide" key={`statistic-${i}`}>
            <StatisticBlock {...statistic} />
          </li>
        )}
      </Carousel>
    );
  }

  renderStatisticsList = () => (
    <ul className={styles.statisticsList}>
      {this.renderStatistics()}
    </ul>
  )

  renderOffers = () => {
    const { offers } = this.props;

    return offers.map((offer, i) =>
      <li className={styles.offerItem} key={`offer-${i}`}>
        <OfferBlock {...offer} />
      </li>
    );
  }

  renderStatistics = () => {
    const { statistics } = this.props;

    return statistics.map((statistic, i) =>
      <li className={styles.statisticsItem} key={`statistic-${i}`}>
        <StatisticBlock {...statistic} />
      </li>
    );
  }

  render () {
    const { activeSlide } = this.state;
    const { isMobile, className, backgroundImage } = this.props;

    return (
      <section className={classnames(styles.advantages, className)} style={{ backgroundImage: `url('${backgroundImage}')`}}>
        <div className={styles.offers}>
          <p className={styles.title}>What we&#39;ll offer:</p>
          <ul className={styles.offersList}>
            {this.renderOffers()}
          </ul>
        </div>
        <div className={styles.statistics}>
          {isMobile ? this.renderStatisticsCarousel() : this.renderStatisticsList()}
          {
            isMobile && 
              <div className={styles.carouselPagination}>
                <CarouselPagination
                  autoplay
                  totalItems={this.totalStatistics}
                  currentPage={activeSlide}
                  onPageChange={this.carouselHandler}
                  dark
                />
              </div>
          }
        </div>
      </section>
    );
  }
}

export default isMobileHOC(AdvantagesBanner);


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/AdvantagesBanner/AdvantagesBanner.js